import store from "@/store";
import permissions from "./permissions";
import domain from "./domain";

const host = window.location.hostname.split(".")[0];
var isAgent = host === "agent" || host === "homolog-agent";
var boolCasino = !isAgent && store.state.operators.casino == "1";
var boolCasinoLive = !isAgent && store.state.operators.casino == "2";
var isCredit2 = store.state.operators.credit === "2"; // Icones são apenas para operadores online;
// var logged = store.state.logged.status;
// const showWorldCup = !logged
//   ? isCredit2 && store.state.operators.retail == 0
//   : isCredit2;
var hasIcon = permissions().customIcons.appbar;
const baseUrlS3 = `https://dozr8la71aog.cloudfront.net/domains/${domain()}/img/custom/icons/appbar`;

// const longTermSportId = 555;
const sports = store.state.sports;
// let hasLongTerm = false;

// if (sports) {
//   if (sports.find((sport) => sport.id_sport == longTermSportId)) {
//     hasLongTerm = true;
//   }
// }

// Translation menu list
let translate = {
  pt: {
    sports: "Esportes",
    live: "Ao vivo",
    mybets: "Minhas Apostas",
    casino: "Cassino",
    liveCasino: "Cassino ao vivo",
    validate: "Validar",
    worldCup: "Copa do Mundo",
    worldCupWinner: "Vencedor do BBB",
    promotions: "Promoções",
    winner: "Vencedor",
  },
  en: {
    sports: "Sports",
    live: "Live",
    mybets: "My Bets",
    casino: "Casino",
    liveCasino: "Live Casino",
    validate: "Validate",
    worldCup: "World Cup",
    worldCupWinner: "Winner BBB",
    promotions: "Promotions",
    winner: "Winner",
  },
  es: {
    sports: "Deportes",
    live: "En vivo",
    mybets: "Mis Apuestas",
    casino: "Casino",
    liveCasino: "Casino en Vivo",
    validate: "Validar",
    worldCup: "Copa del Mundo",
    worldCupWinner: "Ganador del BBB",
    promotions: "Promociones",
    winner: "Ganador",
  },
};

const mainMenu = () => {
  // Language menu
  let lang = localStorage.getItem("language") || store.state.language || "pt";

  const worldCupDomains = ["cartola", "dasorte", "betdasorte"];

  const showWorldCup =
    worldCupDomains.includes(domain()) &&
    sports.find((sport) => sport.id_sport == 100);

  return [
    // Sports
    {
      route: permissions().bigTable
        ? { name: "bigTable", hash: "#scrollTop" }
        : {
            name: "Sports",
            query: {
              sport: store.getters.getNameSportById("6046"),
              live: store.getters.getNameSportById("6046"),
            },
            hash: "#scrollTop",
          },
      label: translate[lang].sports,
      icon_img: hasIcon ? `${baseUrlS3}/sports50.png` : "",
      icon: "mdi-home-outline",
      class: "",
      show: true,
    },
    // Ao Vivo
    {
      route: {
        name: "live",
        query: { live: store.getters.getNameSportById("6046") },
        hash: "#scrollTop",
      },
      label: translate[lang].live,
      icon_img: hasIcon ? `${baseUrlS3}/live50.png` : "",
      icon: "mdi-access-point",
      class: "live-ani primary--text",
      show: true,
    },
    {
      route: {
        name: "worldCup",
        query: {
          sport: translate[lang].winner,
          category: "Lagoa Azul 5",
          event: 1228531,
        },
        hash: "#scrollTop",
      },
      label: "Lagoa Azul 5",
      isWorldCup: true,
      icon: "mdi-trophy",
      class: "",
      show: showWorldCup,
    },
    {
      route: {
        name: "worldCup",
        query: {
          sport: translate[lang].winner,
          category: "Lagoa Azul 7",
          event: 1228532,
        },
        hash: "#scrollTop",
      },
      label: "Lagoa Azul 7",
      isWorldCup: true,
      icon: "mdi-trophy",
      class: "",
      show: showWorldCup,
    },
    {
      route: {
        name: "worldCup",
        query: {
          sport: translate[lang].winner,
          category: "Lagoa Azul 9",
          event: 1228533,
        },
        hash: "#scrollTop",
      },
      label: "Lagoa Azul 9",
      isWorldCup: true,
      icon: "mdi-trophy",
      class: "",
      show: showWorldCup,
    },
    // {
    //   route: {
    //     name: "worldCupWinner",
    //     query: {
    //       sport:
    //         !isAgent && showWorldCup && hasLongTerm
    //           ? store.getters.getNameSportById("51")
    //           : "",
    //       event: translate[lang].worldCupWinner,
    //     },
    //     hash: "#scrollTop",
    //   },
    //   label: translate[lang].worldCupWinner,
    //   isWorldCup: true,
    //   icon_img: "",
    //   icon: "mdi-eye-plus-outline",
    //   class: "",
    //   show: !isAgent && showWorldCup && hasLongTerm,
    // },
    // Cassino
    {
      route: {
        name: "casinoLobby",
        params: { casinoType: "casino" },
        hash: "#scrollTop",
      },
      label: translate[lang].casino,
      icon_img: hasIcon ? `${baseUrlS3}/cassino50.png` : "",
      icon: "mdi-slot-machine-outline",
      class: "",
      show: boolCasino || boolCasinoLive,
    },
    // Cassino Ao Vivo
    // Dados do route está sendo adicionado diretamente no main_menu_list
    // pois estava dando error 'getBoundingClientRect'
    {
      route: {
        name: "casinoLobby",
        params: { casinoType: "live" },
        hash: "#scrollTop",
      },
      label: translate[lang].liveCasino,
      icon_img: hasIcon ? `${baseUrlS3}/cassinolive50.png` : "",
      icon: "mdi-cards-club",
      class: "live-ani primary--text",
      show: boolCasinoLive,
    },
    // Spaceman
    // {
    //   route: logged
    //     ? {
    //         name: "casino-game",
    //         params: { gameID: "1301", isFreeGame: "false" },
    //       }
    //     : {
    //         name: "casinoSpaceman",
    //         query: { gameSearch: "spaceman" },
    //         hash: "#scrollTop",
    //       },
    //   label: "Spaceman",
    //   icon_img: hasIcon ? `${baseUrlS3}/spaceman50.png` : "",
    //   icon: "mdi-rocket",
    //   class: "",
    //   show: boolCasinoLive,
    // },
    // Minhas Apostas
    {
      route: { name: "myBets", hash: "#scrollTop" },
      label: translate[lang].mybets,
      icon_img: hasIcon ? `${baseUrlS3}/mybets50.png` : "",
      icon: "mdi-receipt-text",
      class: "",
      show: !isAgent && store.state.logged.status,
    },
    // Promoções
    {
      route: { name: "AllPromotions", hash: "#scrollTop" },
      label: translate[lang].promotions,
      icon_img: hasIcon ? `${baseUrlS3}/promotions50.png` : "",
      icon: "mdi-gift-outline",
      class: "",
      show: isCredit2 && !isAgent,
    },
    // Validar PreBet
    {
      route: { name: "validatePreBet", hash: "#scrollTop" },
      label: translate[lang].validate,
      icon_img: "",
      icon: "mdi-receipt-text-check",
      class: "",
      show: isAgent,
    },
  ];
};

export default mainMenu;
